/**
 * Created by desheng.zhao on 2019/6/17.
 */
import { mapActions } from 'vuex';
export default {
  methods: {
    pushInfo(info){
      this.addInfo({
        page: this.$t(this.$router.currentRoute.meta.title),
        info
      });
    },
    ...mapActions(["addInfo"]),
  }
}


// WEBPACK FOOTER //
// ./src/mixin/info.js